<template>
  <div class="register">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              fixed
              title="客户报备"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--输入框-->
    <div>
      <van-cell-group>
        <van-field v-model="name" label="姓名" placeholder="请输入姓名" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="phone" label="电话或微信号" placeholder="请输入手机号或微信号" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="xuqiu" label="加盟代理意向" placeholder="请说明加盟代理意向" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="kehulaiyuan" label="客户来源" placeholder="请输入客户来源" />
      </van-cell-group>
      <van-cell-group>
        <van-field
           v-model="shuoming"
           rows="3"
           autosize
           type="textarea"
           maxlength="60"
           show-word-limit
           label="跟进情况"
           placeholder="请说明跟进情况" />
      </van-cell-group>
    </div>
    <div style="width: 80%; margin:10px auto 0 auto;">
      <van-button type="primary" block @click="setLogin">提 交</van-button>
    </div>
  </div>
</template>

<script>
import ls from '../../utils/localStorage.js'
import {mapActions} from 'vuex'
export default {
    'name': 'Register',
    data() {
        return {
            name: '',
            phone: '',
            xuqiu: '',
            kehulaiyuan: '',
            shuoming: ''
        };
    },
    methods: {
        ...mapActions(['requestReport']),
        onClickLeft() {
            this.$router.push({path: '/home'});
        },
        setLogin() {

            if (this.name=== ''){
                this.$toast('姓名必填');
                return false;
            };

            if (this.phone=== ''){
                this.$toast('手机号或微信号必填');
                return false;
            };

            // 注册提示，组装数据区
            const registerToast = this.$toast.loading({
                mask: true,
                message: '正在处理...',
                duration:0
            });

            let data = {
                name: this.name,
                phone: this.phone,
                xuqiu: this.xuqiu,
                kehulaiyuan: this.kehulaiyuan,
                shuoming: this.shuoming,
               // user_id: this.$store.state.user.user_info.id,
               user_id: ls.getItem('user_info') ? ls.getItem('user_info').id : null,
            }

            console.log(data);

            // vuex 处理逻辑
            this.requestReport({"data":data,"thit":this,"registerToast":registerToast});
        }
    }
};
</script>

<style scoped>
.register >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.register >>> .van-nav-bar__text {
  color: #fff;
}
.register >>> .van-nav-bar__title {
  color: #fff;
}
.register >>> .van-nav-bar .van-icon {
  color: #fff;
}
.register >>> .van-button--primary {
  color: #fff;
  background-color: #ff8917;
  border: 0.02667rem solid #ff8917;
}
</style>
